import { render, staticRenderFns } from "./SyntheseTechniqueDetail.vue?vue&type=template&id=1cde1852&scoped=true"
import script from "./SyntheseTechniqueDetail.vue?vue&type=script&lang=js"
export * from "./SyntheseTechniqueDetail.vue?vue&type=script&lang=js"
import style0 from "./SyntheseTechniqueDetail.vue?vue&type=style&index=0&id=1cde1852&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cde1852",
  null
  
)

export default component.exports